
import { Button, Checkbox, Alert } from 'element-ui';
import { InfoIcon } from 'vue-feather-icons';
import { loadScript } from '@paypal/paypal-js';
import PaypalPayment from '@/services/payments/PaypalPayment';
import cartMixin from '@/mixins/cartMixin';
import addressMixin from '@/mixins/addressMixin';
import checkoutPaymentMixin from '@/mixins/checkoutPaymentMixin';

export default {
  mixins: [cartMixin, addressMixin, checkoutPaymentMixin],
  props: {
    paymentMethod: {
      type: Object,
    },
  },
  data() {
    return {
      disabled: false,
      generalConditionsSale: false,
    };
  },
  computed: {
    paypalPayment() {
      return new PaypalPayment({
        cart: this.cart,
        auth: this.$auth,
        http: this.$http,
        addressService: this.addressService,
      });
    },
    getCurrency() {
      return this.cart?.Currency?.IsoCode;
    },
  },
  mounted() {
    if (this.$refs['paypal-button-container'].innerHTML.trim() === '') {
      this.startPayement();
    }
  },
  methods: {
    startPayement() {
      const lang = this.$i18n.locale;
      let locale;

      if (lang === 'fr') {
        locale = `${lang}_${lang.toUpperCase()}`;
      } else if (lang === 'de') {
        locale = `${lang}_${lang.toUpperCase()}`;
      } else if (lang === 'en') {
        locale = `${lang}_US`;
      }

      loadScript({
        'client-id': process.env.PAYPAL_CLIENT_ID,
        currency: this.getCurrency,
        locale: locale,
      })
        .then((paypal) => {
          paypal
            .Buttons({
              style: {
                disableMaxWidth: true,
                layout: 'horizontal',
                color: 'black',
                shape: 'rect',
                label: 'paypal',
              },
              onClick: async (data, actions) => {
                this.$store.commit('checkout/setRefreshPaymentMethods', false);
                if (this.checkFormOk()) {
                  const saved = await this.ensureAddressesSaved();
                  if (saved) {
                    return actions.resolve();
                  }
                }
                return actions.reject();
              },
              createOrder: async (data, actions) => {
                let discount = this.cart?.Total?.Discount?.TaxIncl;

                const orderData = {
                  purchase_units: [
                    {
                      amount: {
                        currency_code: this.getCurrency,
                        value: this.cart?.Total?.ToPay?.TaxIncl,
                        breakdown: {
                          item_total: {
                            currency_code: this.getCurrency,
                            value: this.cart?.Total?.Product?.TaxIncl,
                          },
                          discount: {
                            currency_code: this.getCurrency,
                            value: discount,
                          },
                          shipping: {
                            currency_code: this.getCurrency,
                            value: this.isDigitalCart
                              ? 0
                              : this.paypalPayment.shipping?.TaxIncl,
                          },
                        },
                      },
                      custom_id: this.cart.IdCart,
                      items: this.paypalPayment.basket,
                    },
                  ],
                };

                if (this.isDigitalCart) {
                  orderData.application_context = {
                    shipping_preference: 'NO_SHIPPING',
                  };
                }

                return actions.order.create(orderData);
              },
              onApprove: (data, actions) => {
                const $this = this;
                return actions.order.capture().then(async function (details) {
                  $this.addPaymentInfoGtm('PayPal');
                  $this.$router.push(
                    $this.localePath(
                      `/cart/thanks/accepted?orderid=${data.orderID}&cartid=${$this.cartService.idCart}`
                    )
                  );
                });
              },
            })
            .render('#paypal-button-container');
        })
        .catch((err) => {
          console.error('failed to load the PayPal JS SDK script', err);
        });
    },
  },
  components: { Button, InfoIcon, Checkbox, Alert },
};
